import './TabBar.css'
import type { ReactNode } from 'react'
import { cn } from '@/utilities/misc'

export type TabBarOption<T extends string = string> = {
  value: T
  label: ReactNode
  disabled?: boolean
}

export type TabBarProps<T extends string = string> = {
  options: TabBarOption<T>[]
  value: T
  setValue: (value: T) => void
  ariaLabel?: string
  className?: string
  disabled?: boolean
}

export function TabBar<T extends string = string>({
  options,
  value,
  setValue,
  ariaLabel,
  className,
  disabled,
}: TabBarProps<T>) {
  return (
    <div
      className={cn('TabBar', className)}
      role='tablist'
      aria-label={ariaLabel}
    >
      {options.map(option => {
        const active = option.value === value
        const tabDisabled = disabled || option.disabled
        return (
          <button
            key={option.value}
            type='button'
            role='tab'
            aria-selected={active}
            disabled={tabDisabled}
            className={cn('Tab', active && 'Active')}
            onClick={() => {
              if (!tabDisabled) setValue(option.value)
            }}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}
